import TagsListFilterableNew, {
  type TagsListFilterableProps,
} from "components/TagsListFilterableNew";

import TableCellEmpty from "./CellEmpty";

type TableCellLabelsProps = Pick<
  TagsListFilterableProps,
  "tags" | "applyLabelFilter" | "applyFolderFilter"
>;

/**
 * TODO: adopt showing labels in the table cell with new actions flow
 */
const TableCellLabels = (props: TableCellLabelsProps) => {
  if (!props.tags.length) {
    return <TableCellEmpty />;
  }

  return <TagsListFilterableNew {...props} />;
};

TableCellLabels.displayName = "DS.Table.CellLabels";

export default TableCellLabels;
